import { writable, derived } from 'svelte/store';

/**
 * Store for current user's roles.
 */
export const userRoles = writable([]);

export const rolesLoading = writable(false);

// Role checks — admin always passes
export const isAdmin = derived(userRoles, $roles => $roles.includes('admin'));
export const isOperator = derived(userRoles, $roles => $roles.includes('operator') || $roles.includes('admin'));
export const isReadonly = derived(userRoles, $roles => $roles.includes('readonly'));
export const isCommercialista = derived(userRoles, $roles => $roles.includes('commercialista'));

// Permission-based checks
export const canManageInvoices = derived(userRoles, $roles =>
  $roles.includes('admin') || $roles.includes('operator')
);
export const canViewInvoices = derived(userRoles, $roles =>
  $roles.includes('admin') || $roles.includes('operator') || $roles.includes('readonly') || $roles.includes('commercialista')
);
export const canManageCustomers = derived(userRoles, $roles =>
  $roles.includes('admin') || $roles.includes('operator')
);
export const canManagePaymentMethods = derived(userRoles, $roles =>
  $roles.includes('admin') || $roles.includes('operator')
);
export const canManageUsers = derived(userRoles, $roles => $roles.includes('admin'));
export const canManageCompany = derived(userRoles, $roles => $roles.includes('admin'));
export const canViewDiagnostics = derived(userRoles, $roles => $roles.includes('admin'));

/**
 * Load roles from user object (called after auth check).
 */
export function setUserRoles(roles) {
  userRoles.set(roles || []);
}

/**
 * Clear roles (on logout).
 */
export function clearUserRoles() {
  userRoles.set([]);
}

/**
 * Check if user has a specific role (admin always passes).
 */
export function hasRole(role) {
  return derived(userRoles, $roles => $roles.includes(role) || $roles.includes('admin'));
}
